import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { noImageMan, noImageWoman } from "../assets";
import { Header, Navbar, Footer, MarkdownParser } from "../components";
import { GenericMarkdownLoadingSkeleton } from "../components/LoadingSkeleton";
import ErrorPage from "./ErrorPage";
import customAxios from "../utils/customAxios";

import { styles } from "../styles";

const SambutanPage = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  // Fetch Rector data from the new API endpoint
  const { data, isLoading, isError } = useQuery({
    queryKey: ["welcomeSpeeches"],
    queryFn: async () => {
      const response = await customAxios.get("welcome-speeches");
      return response?.data?.data[0] || null;
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });

  if (isError) {
    return (
      <ErrorPage
        code="500"
        titleKey="error.500_title"
        defaultTitle="Gagal Memuat Data"
        subtitleKey="error.500_subtitle"
        defaultSubtitle="Terjadi masalah saat terhubung ke server kami. Silakan coba lagi nanti atau kembali ke"
      />
    );
  }

  const renderContent = () => {
    if (isLoading)
      return (
        <>
          <section className="flex flex-col items-center gap-4 w-fit">
            <div className="w-[280px] h-[350px] bg-neutral-30 animate-pulse rounded-md"></div>
            <div className="flex flex-col items-center gap-2">
              <div className="w-48 h-6 rounded bg-neutral-30 animate-pulse"></div>
              <div className="w-48 h-6 rounded bg-neutral-30 animate-pulse"></div>
            </div>
          </section>
          <section className="w-full">
            <GenericMarkdownLoadingSkeleton />
          </section>
        </>
      );
    if (!data) return null;

    const { content_en, content_id, rector_info } = data || {};

    const {
      image,
      customImage,
      name,
      gender,
      custom_name,
      leadership_field_en,
      leadership_field_id,
    } = rector_info || {};

    // Use dynamic API data, or fall back to the static assets/hardcoded names if unavailable
    const displayImage =
      customImage ||
      image ||
      (gender.toLowerCase() === "female" ? noImageWoman : noImageMan);
    const displayName =
      custom_name || name || "Rektor Universitas Almarisah Madani";

    return (
      <>
        <section className="flex flex-col items-center gap-4 w-fit">
          <img
            src={displayImage}
            alt="Rektor Univeral"
            className="max-w-[280px] rounded-md object-cover"
          />

          <div className="flex flex-col items-center gap-2">
            <h3 className={`${styles.headingS} text-primary-40 text-center`}>
              {displayName}
            </h3>
            <p className={`${styles.textLRegular} text-center`}>
              {currentLanguage === "en"
                ? leadership_field_en
                : leadership_field_id}
            </p>
          </div>
        </section>
        <section className="w-full">
          <MarkdownParser
            content={currentLanguage === "en" ? content_en : content_id}
          />
        </section>
      </>
    );
  };

  return (
    <>
      <Navbar />
      <Header title={t("sambutan.header")} />
      <main className={`${styles.paddingX} w-full py-20 min-h-[600px]`}>
        <section className="flex smd:flex-col smd:items-center mx-auto gap-16 w-full max-w-[1152px]">
          {renderContent()}
        </section>
      </main>
      <Footer />
    </>
  );
};

export default SambutanPage;
